<template>
  <div class="nav-cont m-b-10">
    <div>
        <div
          v-if="games.length > 0"
        class="game_title-ss d-flex-s"
        style="align-items: flex-start"
      >
        <div class="d-flex m-t-5">
          <img :src="siderData.icon" width="25" class="m-l-5" />
          <span class="m-l-5">{{ siderData.name }}</span>
        </div>

        <div class="d-flex">
          <div
            @click="openAll()"
            class="resher-i--bg m-r-5"
            style="padding: 6px 5px"
          >
            {{ $lang.common_txt60 }} {{ games.length }}
          </div>
          <div class="resher-i--bg2 m-r-5">
            <van-icon @click="prevPage()" name="arrow-left" size="15" />
          </div>

          <div class="resher-i--bg2 m-r-10">
            <van-icon @click="nextPage()" name="arrow" size="15" />
          </div>
          <!-- <div
            @click="openAll()"
            class="resher-i--bg"
            style="padding: 6px 10px"
          >
            {{ $lang.common_txt61 }}
          </div> -->
        </div>
      </div>

      <!-- Swipe 容器 -->
      <div>
        <van-swipe
          class="my-swipe"
          :loop="false"
          :touchable="true"
          :autoplay="0"
          :indicator-color="'#1baeae'"
          @change="onChange"
          ref="swipe"
        >
          <!-- 每一页的内容 -->
          <van-swipe-item v-for="(page, index) in pages" :key="index">
            <div class="swipe-item">
              <!-- <div v-for="(item, index) in page" :key="index" class="item">
              <img :src="item.gameIcon" alt="" />
              <p>{{ item.gameName }}</p>
            </div> -->
              <template v-for="(item, index) in page">
              <van-image
                v-if="item.gameIcon"
                radius="10"
                :key="index"
                @click="goToGame(item.gid, item)"
                class="item"
                style="position: relative"
                :src="item.gameIcon"
                lazy-load
              >
                <template v-slot:loading>
                  <van-loading size="20" color="#ff5a1f" vertical />
                </template>
                <img
                  v-if="!isFavorite(item)"
                  @click.stop="toggleFavorite(item)"
                  src="../../assets/img/common/scyx.png"
                  width="20"
                  style="position: absolute; right: 5px; top: 5px"
                />
                <img
                  v-if="isFavorite(item)"
                  @click.stop="toggleFavorite(item)"
                  src="../../assets/img/common/scyx-a.png"
                  width="20"
                  style="position: absolute; right: 5px; top: 5px"
                />
                <div
                  v-if="siderData && siderData.showName === 'yes'"
                  style="
                    position: absolute;
                    text-align: center;
                    bottom: 5px;
                    width: 100%;
                    color: #ffffff;
                  "
                >
                  {{ item.gameName }}
                </div>
                <!-- <div
                v-if="['2000110'].includes(siderData.code)"
                class="d-flex"
                style="
                  width: 100%;
                  position: absolute;
                  right: 0;
                  left: 0;
                  bottom: 0;
                  backdrop-filter: blur(10px) grayscale(30%);
                  height: 42px;
                  border-radius: 0 0 10px 10px;
                  justify-content: center;
                  word-wrap: break-word; /* 允许单词在容器内强制换行 */
                "
              >
                <p style="width: 90%; margin: 0 auto; text-align: center">
                  {{ item.gameName }}
                </p>
              </div> -->
              </van-image>
              <div
                v-else
                :key="'fb' + index"
                class="item game-fallback"
                @click="goToGame(item.gid, item)"
              >
                <span class="game-fallback__txt">{{ item.gameName }}</span>
              </div>
              </template>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>
    <login v-model="showPopup" overlay></login>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { buildLaunchPayload, launchGame } from '@/components/home/gameLaunch'
import { isFavoriteGame } from '@/store/favoritesStorage'
export default {
  name: 'ResherSiper',
  components: {},
  props: {
    siderIndex: {
      type: Number
    },
    siderData: {
      type: Object,
      default: () => ({ games: [] })
    }
  },
  data() {
    return {
      currentPage2: 0,
      showPopup: false
    }
  },
  computed: {
    ...mapState(['favorites']),
    games() {
      return Array.isArray(this.siderData && this.siderData.games)
        ? this.siderData.games
        : []
    },
    pages() {
      const pages = []
      // if (this.siderIndex === 0) {
      //   for (let i = 0; i < this.siderData.games.length; i += 9) {
      //     pages.push(this.siderData.games.slice(i, i + 9))
      //   }
      // } else {
      for (let i = 0; i < this.games.length; i += 6) {
        pages.push(this.games.slice(i, i + 6))
      }
      // }

      return pages
    }
  },
  mounted() {},
  methods: {
    ...mapActions(['addFavorite', 'removeFavorite']),
    // 检查当前游戏是否在对应currency的收藏列表中
    isFavorite(item) {
      return isFavoriteGame(this.favorites, this.getCurrency, item)
    },
    openAll() {
      const base = typeof this.siderIndex === 'number' ? this.siderIndex : 0
      const partCode = (this.siderData && this.siderData.code) || ''
      this.$jumpTo('/category', { gameTab: base + 1, partCode })
    },
    onChange(index) {
      this.currentPage2 = index
    },
    prevPage() {
      if (this.currentPage2 > 0) {
        this.$refs.swipe.swipeTo(this.currentPage2 - 1)
      }
    },
    nextPage() {
      if (this.currentPage2 < this.pages.length - 1) {
        this.$refs.swipe.swipeTo(this.currentPage2 + 1)
      }
    },
    // 切换收藏状态
    toggleFavorite(item) {
      if (!this.token) {
        this.showPopup = true
        return
      }
      // 构造payload，包含当前currency和游戏项
      const payload = {
        currency: this.getCurrency,
        item: item
      }
      if (this.isFavorite(item)) {
        this.removeFavorite(payload)
      } else {
        this.addFavorite(payload)
      }
    },
    goToGame(v, v2) {
      if (this.token) {
        const game = v2 || (v && typeof v === 'object' ? v : null)
        const jumpPayload = buildLaunchPayload(game, {
          typeCode: this.siderData && this.siderData.code,
          typeCate: 1
        })
        if (!jumpPayload) {
          this.$toast({
            message: this.$lang.common_txt145,
            icon: 'cross'
          })
          return
        }
        launchGame(this, jumpPayload)
      } else {
        this.showPopup = true
      }
    }
  }
}
</script>
<style lang="less" scoped>
.my-swipe {
  width: 100%;
  // height: 300px; /* 根据实际需求调整高度 */
  /* 隐藏指示器 */
  ::v-deep .van-swipe__indicators {
    display: none;
  }
}

.swipe-item {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 0 5px;
}
.swipe-item::after {
  content: '';
  width: 31.5%; /* 与.item宽度一致 */
  height: 0; /* 不占用高度 */
}
.item {
  max-height: 180px;
  width: 31.5%; /* 每个元素占 32% 的宽度 */
  margin-bottom: 10px; /* 调整元素之间的间距 */
  text-align: center;
  ::v-deep .van-image__img {
    border-radius: 10px;
  }
  ::v-deep .van-loading__spinner {
    display: none;
  }
}
.game-fallback {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  min-height: 96px;
  padding: 8px;
  background: linear-gradient(135deg, #2b2d3a, #3a3d4e);
  border-radius: 10px;
  cursor: pointer;
}
.game-fallback__txt {
  color: #cfd3e0;
  font-size: 12px;
  line-height: 1.3;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.resher-i--bg {
  padding: 5px;
  // opacity: 0.6;
  background: #363849;
  border-radius: 5px;
  // color: #fc8585;
  // border: 1px solid #733838;
}

.resher-i--bg2 {
  padding: 5px;
  // opacity: 0.6;
  background: #363849;
  border-radius: 5px;
  color: #ffffff;
}
.game_title {
  background: url(../../assets/img/otgame/beijin_12.png) no-repeat;
  background-size: 100% 100%;
  height: 50px;
}
.game_title-ss {
  background: url(../../assets/img/otgame/beijin_12.png) no-repeat;
  background-size: 100% 100%;
  height: 138px;
  margin-bottom: -93px;
}
</style>
